import { Alert, Button } from "reactstrap";
import React, { useEffect, useState } from "react";

import { Drawer } from "../../components/Drawer";

export default function CropsModal(props) {
  const [cropName, setCropName] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [cropId, setCropId] = useState(null);

  useEffect(() => {
    if (props.cropToUpdate) {
      setCropName(props.cropToUpdate.name);
      setCropId(props.cropToUpdate.id);
    }
  }, [props.cropToUpdate]);

  const addNewCrop = () => {
    /* const new_crop = { name: cropName }; */
    props.createCrop({ name: cropName });
    setCropName("");
  };

  const updateCurrentCrop = (crop) => {
    props.updateCrop(crop);
    setCropId(null);
    setCropName("");
  };

  const submitForm = () => {
    if (cropName === "") {
      setShowAlert(true);
    } else {
      setShowAlert(false);
      if (cropId) updateCurrentCrop({ id: cropId, name: cropName });
      else addNewCrop();

      props.setCropToUpdate(null);
      props.setOpenModalCrop(false);
    }
  };
  const cancel = () => {
    setCropId(null);
    setCropName("");
    setShowAlert(false);
    props.setCropToUpdate(null);
    props.setOpenModalCrop(false);
  };

  const footer = (
    <>
      <Button color="secondary" onClick={() => cancel()}>
        Cancel
      </Button>
      <Button
        color="primary"
        className="btn"
        type="submit"
        form="cropsForm"
        onClick={() => submitForm()}
      >
        {cropId ? "Update" : "Create"} crop
      </Button>
    </>
  );

  return (
    <Drawer
      isOpen={props.isOpen}
      onClose={() => cancel()}
      title={`${cropId ? "Update" : "Create"} crop`}
      footer={footer}
    >
      {showAlert && <Alert color="danger">The crop's name is required</Alert>}
      <form id="cropsForm">
        <div className="mb-3">
          <label className="col-form-label">Name *</label>
          <input
            className="form-control"
            defaultValue={cropName}
            type="text"
            onChange={(e) => setCropName(e.target.value)}
            required
          />
        </div>
      </form>
    </Drawer>
  );
}
